import { Screening_Views_Bool_Exp } from "generated/graphql";
import { ScreeningViewId } from "types/screeningViewType";

export const maybeScreeningViewIdFilter = (
    screeningViewId?: ScreeningViewId
): Screening_Views_Bool_Exp => {
    return screeningViewId ? { id: { _eq: screeningViewId } } : {};
};
